<template>
    <div>
        <div v-if="edit">
            <div v-if="field.type === 'text'" class="form-group">
                <label for="field.name">{{ field.title }}</label>
                <input
                    class="form-control form-control-sm"
                    type="text"
                    :ref="field.name"
                    :id="field.name"
                    :value="field.value"
                    @input="$emit('set-value', $event.target.value)"
                />
            </div>
            <div v-if="field.type === 'date'" class="form-group">
                <label for="field.name">{{ field.title }}</label>
                <v-date-picker
                    class="form-control form-control-sm"
                    popover-align="right"
                    :ref="field.name"
                    :id="field.name"
                    :value="field.value"
                    @input="$emit('set-value', $event.target.value)"
                ></v-date-picker>
            </div>
            <div v-if="field.type === 'file'" class="form-group">
                <label for="field.name">{{ field.title }}</label>
                <input
                    class="form-control form-control-form-control-file"
                    type="file"
                    :ref="field.name"
                    :id="field.name"
                    @change="handleUpload(field.name)"
                />
                {{ field.value }}
            </div>
            <div v-if="field.type === 'textarea'" class="form-group">
                <label for="field.name">{{ field.title }}</label>
                <textarea
                    class="form-control form-control-sm"
                    rows="2"
                    :ref="field.name"
                    :id="field.name"
                    :value="field.value"
                    @input="$emit('set-value', $event.target.value)"
                ></textarea>
            </div>
            <div v-if="field.type === 'select'" class="form-group">
                <label for="field.name">{{ field.title }}</label>
                <select
                    class="form-control form-control-sm"
                    :ref="field.name"
                    :id="field.name"
                    :value="field.value"
                    @input="$emit('set-value', $event.target.value)"
                >
                    <option v-for="o in field.options" :value="o.value">{{ o.title }}</option>
                </select>
            </div>
            <div v-if="field.type === 'radio'" class="form-group">
                <p class="mb-0">{{ field.title }}</p>
                <div v-for="(o, i) in field.options" class="form-check form-check-inline">
                    <input
                        class="form-control-sm mr-2"
                        type="radio"
                        :ref="field.name"
                        :id="`${o.value}${i}`"
                        :value="field.value"
                        :checked="field.value === o.value"
                        @input="$emit('set-value', o.value)"
                    />
                    <label :for="`${o.value}${i}`">{{ o.title }}</label>
                </div>
            </div>
            <div v-if="field.type === 'checkbox'" class="form-check">
                <label for="field.name">{{ field.title }}</label>
                <div v-for="(o, i) in field.options" class="form-group">
                    <input
                        type="checkbox"
                        class="mr-2"
                        :id="`${o.value}${i}`"
                        :ref="field.name"
                        :value="o.value"
                        v-model="o.checked"
                        @input="$emit('set-value', $event.target.value)"
                    />
                    <span :for="`${o.value}${i}`">{{ o.title }}</span>
                </div>
            </div>
        </div>
        <div v-else="">
            <span v-if="field.type == 'file' && field.value">
                <a
                    target="_blank"
                    class="btn btn-primary"
                    :href="`/patients/${patientId}/download/${field.name}`"
                    >Download - {{ field.title }}
                </a>
            </span>
            <span v-else="">{{ field.value }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "MultiField",
    props: ["field", "edit", "patientData", "patientId"],
    created() {
        this.field.value = this.patientData[this.field.name];
    },
    methods: {
        handleUpload(fieldRef) {
            let data = new FormData();
            let uploadEndpoint = `/api/patients/${this.patientId}/uploadFile`;
            data.append("file", this.$refs[fieldRef].files[0]);
            data.append("key", fieldRef);
            data.append("value", this.field.value);
            axios
                .post(uploadEndpoint, data)
                .then(r => {
                    this.$emit("set-value", r.data.file);
                })
                .catch(function(err) {
                    console.error(err);
                });
        },
    },
};
</script>
